import { mobileFaz8Ar } from './mobile.faz8.ar';
/** Android yönetim uygulaması metinleri (Arapça; F7-17). */
export const mobileAr = {
  ...mobileFaz8Ar,
  tabs: {
    home: 'الرئيسية',
    more: 'المزيد',
  },
  setupRequired: 'يتطلب الإعداد',
  help: {
    longPressHint: 'اضغط مطولًا لعرض الشرح.',
  },
  errors: {
    network: 'تعذّر الوصول إلى الخادم. تحقّق من اتصالك بالإنترنت وحاول مرة أخرى.',
    timeout: 'لم يستجب الخادم في الوقت المحدد. حاول مرة أخرى.',
    forbidden: 'ليست لديك صلاحية لهذا الإجراء.',
    generic: 'حدث خطأ غير متوقع. حاول مرة أخرى.',
  },
  signIn: {
    server: 'عنوان لوحة التحكم',
    serverShort: 'لوحة التحكم: {{host}}',
    serverInvalid: 'أدخل عنوان https صالحًا (مثل panel.zootopia.com.tr).',
    expired: 'انتهت جلستك أو أُغلقت من جهاز آخر. يرجى تسجيل الدخول مرة أخرى.',
    signedOut: 'تم تسجيل الخروج. حُذفت بيانات الجلسة على هذا الجهاز.',
    forgotNeedsEmail: 'أدخل بريدك الإلكتروني أولًا لإعادة تعيين كلمة المرور.',
  },
  mfa: {
    backupLead: 'إذا تعذّر عليك الوصول إلى تطبيق المصادقة، فأدخل أحد رموزك الاحتياطية.',
    wrongAccount: 'هل تريد تسجيل الدخول بحساب آخر؟',
    enrollLead:
      'التحقق بخطوتين مطلوب للوحة التحكم. افتح تطبيق مصادقة (Google Authenticator، Microsoft Authenticator، …) على هذا الهاتف، وأضف المفتاح، ثم أدخل الرمز المكوّن من 6 أرقام الذي يعرضه.',
    openAuthenticator: 'فتح في تطبيق المصادقة',
    noAuthenticator: 'لم يُعثر على تطبيق مصادقة. أدخل المفتاح في التطبيق يدويًا.',
    backupWriteDown: 'اكتب الرموز على ورقة أو احفظها في مدير كلمات المرور. لقطات الشاشة محظورة.',
  },
  noOrganization: {
    title: 'حسابك غير مرتبط بأي منشأة',
    lead: 'ربما أُزيلت عضويتك أو عُلّقت. اطلب دعوة من مسؤول منشأتك.',
  },
  lock: {
    title: 'التطبيق مقفل',
    prompt: 'افتح قفل Zootopia Panel',
    unlock: 'فتح القفل',
    failed: 'فشل التحقق. حاول مرة أخرى.',
    setting: 'القفل البيومتري',
    settingLead: 'طلب بصمة الإصبع أو الوجه أو قفل الشاشة عند الفتح',
    unavailable: 'لا يدعم هذا الجهاز المصادقة البيومترية.',
    notEnrolled: 'أضف بصمة إصبع أو وجهًا من إعدادات الهاتف، ثم فعّل هذا الخيار.',
  },
  offline: {
    banner: 'غير متصل — يمكن متابعة الجرد على الجهاز فقط.',
    startup: 'تعذّر الوصول إلى الخادم؛ فُتح التطبيق بآخر جلسة لك. اسحب للأسفل للتحديث عند عودة الاتصال.',
  },
  home: {
    today: 'اليوم',
    ordersToday: 'الطلبات',
    paidToday: 'مدفوعة',
    paidNote: 'إجمالي الطلبات المنشأة اليوم والمدفوعة ({{count}})، دون خصم المبالغ المستردة.',
    mixedCurrency: 'لا تشمل المدفوعات بعملات أخرى.',
    atLeast: '{{count}} على الأقل',
    toPrepare: 'بانتظار التجهيز (مدفوعة)',
    returns: 'طلبات الإرجاع',
    expiring30: 'تنتهي صلاحيتها خلال 30 يومًا',
    paymentReview: 'مدفوعات قيد المراجعة',
    setupOnPanel: 'خطوات الإعداد موجودة في معالج الإعداد في لوحة التحكم.',
    reportsLater:
      'تتوفر تقارير المبيعات والرسوم البيانية مع وحدة التقارير (المرحلة 8). لا تُعرض أرقام تقديرية دون بيانات حقيقية.',
  },
  orders: {
    captureNoteHint: 'مثل رقم الإيصال واسم البنك. 3 أحرف على الأقل.',
    event: 'النشاط',
  },
  returns: {
    lead: 'اضغط على طلب؛ يُتخذ القرار في شاشة الطلب مع المنتجات والمدفوعات.',
    empty: 'لا توجد طلبات بهذه الحالة',
  },
  payments: {
    empty: 'لا توجد مدفوعات بهذه الحالة',
    reviewLead:
      'مدفوعات لا يطابق مبلغها أو حالتها كما أبلغ عنها المزوّد بياناتِ الطلب. لا يُعدّ الطلب مدفوعًا؛ والتفاصيل في لوحة التحكم.',
  },
  products: {
    onHand: 'المخزون {{count}}',
    edit: 'تعديل المنتج',
    longTextOnPanel: 'يتم تعديل الوصف المفصّل والخيارات والفئات وحقول SEO من لوحة التحكم.',
    reviewedAt: 'تاريخ الموافقة',
    assignBarcode: 'تعيين باركود',
    barcodeFormat: 'يجب أن يتكون الباركود من 8 إلى 14 رقمًا.',
    barcodeSaved: 'تم حفظ الباركود.',
    barcodeSavedNoGtin: 'تم حفظ الباركود. تحذير: رقم التحقق لا يشكّل GTIN صالحًا، وقد ترفضه قوائم Google.',
    noPrice: 'لا يوجد سعر',
    price: 'السعر ({{currency}})',
    priceInvalid: 'تعذّرت قراءة المبلغ. مثال: 1299.90',
    priceEmptyHint: 'حفظ قيمة فارغة يزيل السعر من هذه القائمة.',
    priceTaxIncluded: 'الأسعار في هذه القائمة تشمل ضريبة القيمة المضافة.',
    priceTaxExcluded: 'الأسعار في هذه القائمة لا تشمل ضريبة القيمة المضافة.',
    newLead:
      'يُنشأ المنتج كمسودة ولا يظهر في المتجر. أضف الصور والأسعار والمحتوى؛ وتتم الموافقة البيطرية والنشر من شاشة المنتج.',
    created: 'تم إنشاء المنتج كمسودة',
    healthOn: 'تخضع التركيبة وطريقة الاستخدام والتحذيرات للموافقة البيطرية.',
    healthOff: 'لا يوجد محتوى صحي (مثل الإكسسوارات)؛ لا حاجة إلى موافقة بيطرية.',
  },
  photo: {
    camera: 'التقاط صورة',
    library: 'من المعرض',
    uploading: 'جارٍ رفع الصورة…',
    permission: 'لم يُمنح إذن الكاميرا. يمكنك السماح به من إعدادات الهاتف.',
    tooLarge: 'حجم الصورة أكبر من 5 MB. اختر صورة أصغر.',
  },
  scan: {
    title: 'مسح الباركود',
    button: 'مسح الباركود',
    aim: 'ضع الباركود داخل الإطار',
    manual: 'اكتب الرمز',
    permissionTitle: 'إذن الكاميرا مطلوب',
    permissionLead: 'تُستخدم الكاميرا لمسح الباركود. تُعالَج الصور على الجهاز ولا تُرسَل إلى أي مكان.',
    allow: 'السماح بالكاميرا',
    permissionDenied: 'إذن الكاميرا متوقف. يمكنك تفعيله من إعدادات الهاتف.',
    openSettings: 'فتح الإعدادات',
  },
  stock: {
    notFound: 'لم يُعثر على منتج للرمز «{{code}}».',
    expired: 'منتهي الصلاحية',
    adjustmentHint: 'قيمة موجبة للزيادة وسالبة (-) للإنقاص. ذكر السبب مطلوب.',
    dateHint: 'DD.MM.YYYY (مثل 31.12.2027)',
    dateInvalid: 'تعذّرت قراءة التاريخ. مثال: 31.12.2027',
    typeHints: {
      receipt: 'مخزون جديد يدخل المستودع (مع الدفعة وتاريخ انتهاء الصلاحية).',
      adjustment: 'تصحيح سجل خاطئ (+/−) مع ذكر السبب.',
      damage: 'منتجات مكسورة أو تالفة أو مفقودة (تُخصم من المخزون).',
      count: 'تصبح الكمية المعدودة الإجمالي الجديد لهذا المستودع/الدفعة.',
    },
  },
  count: {
    title: 'الجرد بالباركود',
    start: 'الجرد بالباركود',
    lead: 'اختر المستودع المراد جرده. يُحفظ الجرد على الجهاز، ويمكنك متابعة المسح دون إنترنت.',
    begin: 'بدء الجرد',
    lines: 'الأسطر: {{count}}',
    startedAt: 'البدء: {{date}}',
    offlineNote: 'أنت غير متصل. تُحفظ الرموز الممسوحة؛ طابقها وأرسلها عند عودة الاتصال.',
    cameraOn: 'المسح بالكاميرا',
    cameraOff: 'إيقاف الكاميرا',
    manual: 'اكتب الباركود أو SKU',
    notFound: 'لم يُعثر على منتج للرمز «{{code}}». ربما لم يُعيَّن باركود للمنتج.',
    ambiguous: 'الرمز «{{code}}» يطابق أكثر من منتج؛ امسح باستخدام SKU بدلًا من ذلك.',
    savedOffline: 'تم حفظ الرمز، وستتم مطابقته مع منتج عند عودة الاتصال.',
    unresolved: 'أسطر لم تُطابَق مع منتج بعد: {{count}}.',
    resolve: 'مطابقة الآن',
    needLot: 'اختر دفعة للأسطر ({{count}}).',
    empty: 'لم يُمسح شيء بعد',
    emptyLead: 'شغّل الكاميرا وامسح باركود المنتجات؛ كل مسح يضيف قطعة واحدة.',
    unknownProduct: 'رمز غير مطابق',
    lineSent: 'تم الإرسال · الإجمالي الجديد {{onHand}}',
    lineError: 'لم يُرسَل',
    lineUnresolved: 'غير مطابق',
    lineNeedsLot: 'اختر الدفعة',
    counted: 'الكمية المعدودة',
    pickLot: 'اختيار الدفعة',
    changeLot: 'تغيير الدفعة',
    lotLead: 'اختر رقم الدفعة المطبوع على العبوات التي عددتها. يصبح العدد الإجمالي الجديد لتلك الدفعة.',
    noLots: 'لم يُعثر على مخزون بدفعات في هذا المستودع.',
    systemQty: 'في النظام: {{count}}',
    submit: 'إرسال الجرد ({{count}})',
    sent: 'تم إرسال الأسطر: {{count}}.',
    reason: 'جرد عبر الجوال {{date}}',
    discard: 'حذف الجرد',
    discardConfirm: 'سيُحذف الجرد الموجود على هذا الجهاز. تبقى الأسطر المرسلة مسجّلة. هل تريد المتابعة؟',
  },
  review: {
    title: 'بانتظار مراجعة المختص',
    detailTitle: 'مراجعة المختص',
    empty: 'لا يوجد محتوى بانتظار المراجعة',
    count: 'عناصر بانتظار مراجعة المختص: {{count}}.',
    storeNote: 'تُعرض الصفحات والمقالات واللافتات والأسئلة الخاصة بمتجر «{{store}}».',
    inField: 'الحقل: {{field}}',
    content: 'المحتوى',
    hashNote:
      'ترتبط الموافقة بالمحتوى بحالته الحالية. إذا تغيّر لاحقًا فسيحتاج إلى موافقة جديدة، وإذا تغيّر في الأثناء يُرفض القرار ويُطلب منك تحديث الصفحة.',
    noPermission: 'ليست لديك صلاحية اتخاذ قرار بشأن هذا المحتوى.',
    kinds: {
      product: 'منتج',
      post: 'مقالة مدونة',
      page: 'صفحة',
      banner: 'لافتة',
      question: 'سؤال عن المنتج',
    },
    bannerFields: {
      title: 'العنوان',
      text: 'النص',
      ctaLabel: 'نص الزر',
    },
  },
  seo: {
    title: 'ملخص SEO',
    noStore: 'اختر متجرًا لعرض ملخص SEO.',
    fixOnPanel: 'صحّح عناوين المنتجات وأوصافها من شاشة المنتج، والباقي من لوحة التحكم.',
  },
  more: {
    paymentsHint: 'مدفوعات قيد المراجعة ومعلّقة وفاشلة',
    reviewHint: 'للمراجع البيطري المختص',
    version: 'الإصدار {{version}} · {{server}}',
  },
  notifications: {
    title: 'الإشعارات الفورية',
    channel: 'الطلبات والعمليات',
    lead: 'يتلقى هذا الهاتف إشعارات بأحداث مثل طلب جديد أو مراجعة دفعة أو طلب إرجاع. تُرسل فقط الأحداث التي لديك صلاحية عليها؛ ولا تحتوي الإشعارات على بيانات العملاء.',
    device: 'هذا الهاتف',
    on: 'مفعّلة',
    off: 'متوقفة',
    onLead: 'هذا الهاتف مسجّل لتلقي الإشعارات.',
    askLead: 'اسمح بالإشعارات على هذا الهاتف حتى لا تفوتك الطلبات الجديدة.',
    deniedLead: 'لم يُمنح إذن الإشعارات. اضغط الزر ليُطلب منك مرة أخرى.',
    blockedLead: 'الإشعارات متوقفة في إعدادات الهاتف. فعّلها لتطبيق Zootopia Panel من الإعدادات ← الإشعارات.',
    notRegisteredLead: 'الإشعارات مسموح بها لكن هذا الهاتف غير مسجّل (أُزيل أو تعذّر التسجيل).',
    allow: 'تفعيل الإشعارات',
    openSettings: 'فتح إعدادات الهاتف',
    registered: 'تم تفعيل الإشعارات على هذا الهاتف.',
    registerFailed:
      'تعذّر تسجيل هذا الهاتف. تحقق من اتصال الإنترنت وأعد المحاولة؛ وإذا استمرت المشكلة فحدّث خدمات Google Play.',
    removeThisConfirm: 'هل تريد إزالة هذا الهاتف؟ لن تصله إشعارات؛ لإعادة تفعيلها اضغط «تفعيل الإشعارات».',
    deviceDisabled: 'يتعذّر الإرسال',
    unsupported: 'تعمل الإشعارات الفورية في تطبيق Android فقط.',
    setupTitle: 'لا يوجد إعداد للإشعارات في هذا الإصدار',
    setupLead:
      'بُني هذا الإصدار من التطبيق دون إعداد Firebase، لذلك لا يمكن إرسال إشعارات إلى هذا الهاتف. يجب على المسؤول إضافة الإعداد في GitHub وبناء إصدار جديد (دليل بناء Android ← الإشعارات الفورية).',
    meanwhile: 'حتى ذلك الحين تعرض الشاشة الرئيسية ما يحتاج إلى متابعة؛ اسحب للأسفل للتحديث.',
  },
  settings: {
    title: 'الإعدادات',
    signOutConfirm: 'سيتم إغلاق الجلسة على هذا الجهاز وحذف بياناتها.',
    signOutPendingCount:
      'يوجد على هذا الجهاز أسطر جرد غير مرسلة ({{count}})، وسيتم حذفها. هل تريد تسجيل الخروج على أي حال؟',
  },
  organization: {
    switchTitle: 'تبديل المنشأة',
    switchConfirm: 'سيتم حذف البيانات المخزنة مؤقتًا وأي جرد غير مرسل على هذا الجهاز. هل تريد المتابعة؟',
  },
};
